import { render, staticRenderFns } from "./CustomButton.vue?vue&type=template&id=7f6dd0e0&scoped=true&"
import script from "./CustomButton.vue?vue&type=script&lang=ts&"
export * from "./CustomButton.vue?vue&type=script&lang=ts&"
import style0 from "./CustomButton.vue?vue&type=style&index=0&id=7f6dd0e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6dd0e0",
  null
  
)

export default component.exports